import { useContext, useEffect } from "react";
import { Empty, Radio } from "antd";
import { ManifestoConstant, OperationConstant } from "../../../core/_constant";
import style from "./style.module.scss";
import { LandingForm } from "./LandingForm";
import { BoardingForm } from "./BoardingForm";
import { useSearchParams } from "react-router";
import { OperationContext } from "../CreateOperation";

export const ManifestoForm = () => {
  const { initialValue } = useContext(OperationContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const typeFromURL = parseInt(searchParams.get("type") || "");

  const MANIFESTO_ALL_TYPE = [
    initialValue?.debarkationMovement?.id && {
      label: OperationConstant.LANDING_LABEL,
      value: initialValue?.debarkationMovement?.id,
      component: <LandingForm />,
    },
    ,
    initialValue?.embarkationMovement?.id && {
      label: OperationConstant.BOARDING_LABEL,
      value: initialValue?.embarkationMovement?.id,
      component: <BoardingForm />,
    },
    ,
  ]?.filter((item) => item);

  useEffect(() => {
    const currentType = searchParams.get("type");
    if (!currentType || currentType === "undefined") {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("type", MANIFESTO_ALL_TYPE[0]?.value.toString());
      setSearchParams(newParams);
    }
  }, [initialValue]);

  const handleChangeManifestoType = (value: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("type", value?.toString());
    let reachedType = false;
    const keysToDelete: string[] = [];

    newParams.forEach((_, key) => {
      if (reachedType) {
        keysToDelete.push(key);
      }
      if (key === "type") {
        reachedType = true;
      }
    });

    keysToDelete.forEach((key) => newParams.delete(key));

    setSearchParams(newParams);
  };

  const activeComponent =
    MANIFESTO_ALL_TYPE.find((item) => item.value === typeFromURL)?.component ||
    MANIFESTO_ALL_TYPE[0]?.component;

  return (
    <div className={style.manifesto}>
      <div className="">
        { typeFromURL ? (
          <Radio.Group
          // options={MANIFESTO_ALL_TYPE}
          onChange={(e) => handleChangeManifestoType(e.target.value)}
          value={typeFromURL}
          optionType="button"
          buttonStyle="solid"
        >
          {MANIFESTO_ALL_TYPE?.map((item: any) => (
            <Radio value={item?.value}>{item?.label}</Radio>
          ))}
        </Radio.Group>
        ) : 
        (
          <Empty description="En attente de manifeste"/>
        )}
      </div>
      <div className="">{activeComponent}</div>
    </div>
  );
};
